var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transition1063-container"},[_c('div',{staticClass:"scroll-bg one"}),_vm._v(" "),_c('div',{staticClass:"scroll-bg two"},[_c('nuxt-img',{staticClass:"w-100 img-1063",attrs:{"provider":"static","format":"webp","src":"/img/1063-white.png","alt":"1063","sizes":"xs:100vw sm:100vw lg:1920px xl:3000px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }